export default __webpack_public_path__ + "static/media/terra.74479d63.svg";